    import React from 'react';
import './details.css'

import b1 from '../assets/photooneslide.png'
import b2 from '../assets/photoslide2.png'
import b3 from '../assets/photoslide3.png'
import b4 from '../assets/photoslide4.png'
import b5 from '../assets/photoslide5.png'
import b6 from '../assets/photoslide6.png'
import propertyimg1 from "./../assets/cardimg01.jpg"
import propertyimg2 from "./../assets/cardimg02.jpg"
import propertyimg3 from "./../assets/cardimg03.jpg"
import arrow1 from './../assets/arrow.svg'

import Navbar from '../components/farh/layout/nav';
import Swipe from '../components/janna/common/swipe';
import Photoslide from '../components/janna/common/photoslide';
import Propertiydes from '../components/janna/common/propertiydes';
import Footer from '../components/janna/layout/footer'
import Button1 from '../components/farh/common/button'
import Property from '../components/farh/common/property';
import SecHead from '../components/farh/layout/secHeading';
import Community from '../components/janna/common/community';
import ca11 from '../assets/ca1Container.png'
import ca2 from '../assets/ca2.png'
import ca3 from '../assets/ca3Container.png'
import ca4 from '../assets/ca4Container.png'
import ca5 from '../assets/ca5Container.png'
import ca6 from '../assets/ca6Container.png'
import Floorplans from '../components/janna/common/floorplans';
const Details = () => {
    return ( <>

     <Navbar />
     <main>
        <section className='s1product '>
            <div className='pdiv1 floatIn'>
                <Swipe swipe="swipediv" />
                <h2 className='bname'>The Larkin at The Oaks</h2>
                <div className='pricedivv'>
                    <h2 className='pricetext'>price</h2>
                    <h3 className='pricep'>5,800,000 EGP</h3>
                </div>
              
            </div>
              <div className='photosslidediv'>
                    <Photoslide 
                    selectedphoto="photoselected"
                    img11={b1}
                    />
                     <Photoslide 
                    selectedphoto="photoss"
                    img11={b2}
                    />
                     <Photoslide 
                    selectedphoto="photoss"
                    img11={b3}
                    />
                     <Photoslide 
                    selectedphoto="photoss"
                    img11={b4}
                    />
                     <Photoslide 
                    selectedphoto="photoss"
                    img11={b5}
                    />
                     <Photoslide 
                    selectedphoto="photoss"
                    img11={b6}
                    />
                </div>
        </section>
        <section>
           <div className='iframediv'>
                <iframe  className='iframee' src="https://www.3dvista.com/samples/real_estate_virtual_tour.html" title='vr' frameborder="0"></iframe>
             <Button1 className="heroBtn" style2="btn1"  cta="Enter Immersive View" />
           </div>
        </section>
        <section>
            <div className='propertydes'>
                <Propertiydes />
                <div className='propertyovervirediv'>
                    <div className='podiv'>
                        <h2 className='potext'>Property overview</h2>
                        <p className='p1'>Experience luxury living at its finest in this stunning 3-bedroom apartment located in the prestigious Palm Hills development. This meticulously designed residence offers the perfect blend of modern elegance and comfortable living, featuring premium finishes throughout.</p>
                    </div>
                    <div className='propertyodiv2'>
                        <p className='p2'>Step into The Larkin at The Oaks in Skipton… a well-balanced, four double-bedroom home that spans across 3 levels!</p>
                        <div className='propertyodiv3'>
                           <div className='pp4'>
                                <h2 className='ground'>
                                    Lower Ground Floor:
                                    <span className='bold'>A spectacular open-plan kitchen, dining and living space forms the heart of the home. Bi-fold doors open to the garden, filling the space with natural light and creating a bright, welcoming place to cook, relax and gather. A dedicated laundry room and WC complete this practical, well-planned floor.</span>
                                
                                    <span className='newline'>Ground Fl...</span>
                                
                                </h2>
                                <button className='readmore'>Read more</button>
                           </div>
                           <h2 className='thoughtful'>Thoughtful touches
                                <br />
                                A spectacular lower-ground living floor with bi-fold doors
                                Two generous bedroom suites
                                Island Kitchen with Quartz Worktop - a statement centrepiece
                                A large useable garage
                                A separate laundry room to keep life organised
                            git</h2>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
            
            <section>
                <div className='container communitydiv'>
                    <div className='ca1' >
                        <h2 className='catext'>Community Amenities</h2>
                        <div className='cagrid'>
                            <Community 
                            
                            caicon={ca11}
                            catext='High-Speed Internet'/>
                              <Community 
                            stylee="two"
                            caicon={ca2}
                            catext='Fitness Center'/>
                               <Community 
                            stylee="three"
                            caicon={ca3}
                            catext='24/7 Security'/>
                                <Community 
                            stylee="four"
                            caicon={ca4}
                            catext='Landscaped Gardens'/>
                              <Community 
                            stylee="five"
                            caicon={ca5}
                            catext='Covered Parking'/>
                               <Community 
                            stylee="six"
                            caicon={ca6}
                            catext='Restaurant & Café'/>
                        </div>
                    </div>
                    <div className='locationdiv'>
                         <h2 className='catext'>location</h2>
                         <div className='locphoto'></div>
                    </div>
                </div>
            </section>
        <section  >
            <div className='floorplansdiv'>
                  <SecHead style3='secHeading1' title='Floorplans'  />   
                  <div className='fpp1'>
                    <div className='fpp'>
                        <Floorplans 
                        fdtext='Living'
                        fdsize='14 2" × 15 7'/>
                           <Floorplans 
                        fdtext='Kitchen'
                        fdsize='11 7" × 1 11'/>
                           <Floorplans 
                        fdtext='Dining'
                        fdsize='14 2" × 15 7'/>
                           <Floorplans 
                        fdtext='Laundry'
                        fdsize='14 2" × 15 7'/>
                           <Floorplans 
                        fdtext='WC'
                        fdsize='14 2" × 15 7'/>
                          <Floorplans 
                        fdtext='Total SQ'
                        fdsize='2007 sq ft'/>
                    </div>
                    <div className='fpimg'></div>
                  </div>
            </div>
        </section>
         <section>
               <div className='whychooseussec'>
                 <div className="container ">
                    <SecHead style3='secHeading1' title='Featured Developments' sub1="Curated Selection" sub2="Explore handpicked residential and commercial projects across Egypt." />   
                </div>
                <div className='whychooseusdiv1 moveIn scrollAnimate'>
                    {/* 1 */}
                        <Property
                        img={propertyimg1} 
                        location="New Cairo" 
                        title="Palm Hills New Cairo" 
                        price="3,500,000" 
                        statustype="status1" 
                        statustxt="Ready to Move" 
                        />
                        {/* 2 */}
                        <Property 
                        img={propertyimg2} 
                        location="Sheikh Zayed" 
                        title="Zed West Residence" 
                        price="4,200,000" 
                        statustype="status2" 
                        statustxt="Under Construction" 
                        />

                        {/* 3 */}
                        <Property 
                        img={propertyimg3} 
                        location="6th of October" 
                        title="Mountain View iCity" 
                        price="2,850,000" 
                        />
                    </div>
                    <Button1 className="heroBtn" style2="btn1"  cta="Start Exploring" icon={arrow1} />

               </div>
            </section>
        </main>
        <Footer />
    
    </> );
}
 
 
export default Details;